module.exports = __webpack_public_path__ + "img/mediacenter-icon.e66659a6.png";